var bootstrap = require('./bootstrap.js');
var HasClass = require('./helpers/hasClass');
var $ = global.jQuery = require('jquery');
var Nav = require('./helpers/navigation');
var body = new HasClass('body');
global.TweenMax = require('gsap');
require('gsap/src/uncompressed/plugins/ScrollToPlugin');
require('magnific-popup');

var Transe = require('./helpers/transe');
var googleMaps = require('./helpers/map');
var Carousel = require('./helpers/carousel');
var SmoothScroll = require('./helpers/smoothScroll');
var IsTouch = require('./helpers/IsTouch');

var smoothScroll = new SmoothScroll('.content');

const makeVideoPlayableInline = require('iphone-inline-video');

$(document).ready(() => {
    var navigation = new Nav();
    $(document.body).addClass('show');
    main.reservations();
    main.openinghours();
    main.initParallax();
    main.initPages();
});

var main = {
    scrollToMenu() {
        let $scrollTo = $('.js-menu-section');

        let $scrollContainer = $('.content');
        let scrollOffset = $scrollTo.offset().top - 50;

        if (IsTouch()) {
            scrollOffset -= 50;
        }

        TweenMax.to($scrollContainer, 1, {
            scrollTo: {y: scrollOffset, autoKill: true},
            ease: Power1.easeOut,
            overwrite: 5
        });
    },

    initPages() {
        body.has('contact', () => {
            this.map();
        });

        body.has('about', () => {
            this.about();
        });

        body.has('menu', () => {
            this.tabs();
            this.parseMenuHash();

            $('.js-button-seasonality').on('click', event => {
                event.preventDefault();
                this.scrollToMenu();
            });
        });
    },

    parseMenuHash() {
        var param = window.location.hash;

        if (param.length && param == '#/menu-section') {
            this.scrollToMenu();
        }
    },

    initParallax() {
        smoothScroll.init();

        if (!IsTouch()) {
            var transe = new Transe({
                inner: document.getElementById('content'),
                outer: document.getElementById('content'),
                forcesize: false,
                autoresize: false
            });

            transe.addFrame({
                '.cover-image-block': {
                    from: {
                        transform: 'translateY(-50%)'
                    },
                    to: {
                        transform: 'translateY(0%)'
                    }
                },
                '.js-parallax-min-25': {
                    '0%': {
                        transform: 'translateY(0)'
                    },
                    '100%': {
                        transform: 'translateY(-25%)'
                    }
                },
                '.js-parallax-min-15': {
                    '0%': {
                        transform: 'translateY(0)'
                    },
                    '100%': {
                        transform: 'translateY(-15%)'
                    }
                },
                '.js-parallax-plus-25': {
                    '0%': {
                        transform: 'translateY(0)'
                    },
                    '100%': {
                        transform: 'translateY(25%)'
                    }
                },
                '.js-parallax-plus-15': {
                    '0%': {
                        transform: 'translateY(0)'
                    },
                    '100%': {
                        transform: 'translateY(15%)'
                    }
                }
            });
        }
    },

    map() {
        setTimeout(() => {
            googleMaps.init($('.js-acf-map'));
        }, 0);
    },

    about() {
        var video = document.getElementById("bgvid");
        if (video) {
            makeVideoPlayableInline(video, false);
        }

        var aboutSlider = new Carousel('.js-carousel-about', {
            infinite: true,
            speed: 500,
            fade: true,
            autoplay: true,
            autoplaySpeed: 3500,
            cssEase: 'linear'
        });

        var referenceSlider = new Carousel('.js-carousel-reference', {
            infinite: true,
            dots: true,
            arrows: false,
            speed: 500,
            fade: true,
            autoplay: true,
            autoplaySpeed: 3000,
            cssEase: 'linear'
        });
    },

    tabs() {
        $('.tabs li').on('click', (e) => {
            var that = e.currentTarget;
            var tab_id = $(that).attr('data-tab');

            $('.tabs li').removeClass('active');
            $('.tab-content-pane').removeClass('active');

            $(that).addClass('active');
            $("#" + tab_id).addClass('active');
        });
    },

    reservations() {
        var previousId = 0;

        $(document.body).on('click', '.js-reservation-id', e => {
            let $link = $(e.currentTarget);
            let id = $link.data('id');

            if (previousId != id) {
                previousId = id;
                $('.js-reservation-id').toggleClass('active');
            }
        });

        window.reservationpopup = $('.js-reservation').magnificPopup({
            removalDelay: 1200,
            alignTop: true,
            mainClass: 'mfp-slide-right',
            items: {
                src: '//bookings.zenchef.com/results?rid=370841',
                type: 'iframe'
            },
            callbacks: {
                beforeOpen: () => {
                    $('.push-wrapper').addClass('push-back');

                    smoothScroll.unbind();
                },
                beforeClose: () => {
                    $('.push-wrapper').removeClass('push-back');
                    smoothScroll.bind();
                }
            }
        });

        window.shoppopup = $('.js-webshop').magnificPopup({
            removalDelay: 1200,
            alignTop: true,
            mainClass: 'mfp-slide-right',
            items: {
                src: '//bookings.zenchef.com/shop?rid=370841',
                type: 'iframe'
            },
            callbacks: {
                beforeOpen: () => {
                    $('.push-wrapper').addClass('push-back');

                    smoothScroll.unbind();
                },
                beforeClose: () => {
                    $('.push-wrapper').removeClass('push-back');
                    smoothScroll.bind();
                }
            }
        });
    },

    openinghours() {
        $('.js-openinghours').magnificPopup({
            removalDelay: 1200,
            alignTop: true,
            mainClass: 'mfp-slide-left',
            fixedContentPos: false,
            items: {
                src: '#openinghours',
                type: 'inline',
            },
            callbacks: {
                beforeOpen: () => {
                    $('.push-wrapper').addClass('push-back');
                    smoothScroll.unbind();
                },
                beforeClose: () => {
                    $('.push-wrapper').removeClass('push-back');
                    smoothScroll.bind();
                }
            }
        });
    }
};
